import {
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { catchError, first, firstValueFrom, map, throwError } from 'rxjs';

import { Store } from '@ngrx/store';

import { MasterFetchService } from '../../../fetches/services/master-fetch.service';
import { NgRxState } from '../../../modules/app-ngrx.module';
import { MasterAction } from '../../../stored/global/actions';

@Directive({
  selector: '[xbahtMasterPartner]',
})
export class MasterPartnerDirective implements OnInit {
  constructor(
    private ngrxStore: Store<NgRxState>,
    private templateRef: TemplateRef<{
      $implicit: {
        id: string;
        name: string;
        options: string;
      };
      index: number;
      first: boolean;
      last: boolean;
      even: boolean;
      odd: boolean;
      count: number;
    }>,
    private viewContainer: ViewContainerRef,
    private masterFetchService: MasterFetchService
  ) {}

  async ngOnInit(): Promise<void> {
    const partners = await firstValueFrom(
      this.ngrxStore.select('Master').pipe(map((item) => item.partners))
    );
    if (partners.length != 0) {
      for (let index = 0; index < partners.length; index++) {
        this.viewContainer.createEmbeddedView(this.templateRef, {
          $implicit: partners[index],
          index,
          first: index === 0,
          last: index === partners.length - 1,
          even: (index & 1) === 0,
          odd: (index & 1) === 1,
          count: partners.length,
        });
      }
    } else {
      this.masterFetchService
        .partner({})
        .pipe(
          first(),
          catchError((error) => throwError(() => error))
        )
        .subscribe((item) => {
          if (item.status && item.payload) {
            this.ngrxStore.dispatch(
              MasterAction.SetPartner({ partners: item.payload })
            );

            this.viewContainer.clear();
            for (let index = 0; index < item.payload.length; index++) {
              this.viewContainer.createEmbeddedView(this.templateRef, {
                $implicit: item.payload[index],
                index,
                first: index === 0,
                last: index === item.payload.length - 1,
                even: (index & 1) === 0,
                odd: (index & 1) === 1,
                count: item.payload?.length,
              });
            }
          }
        });
    }
  }
}
